import React, {useEffect} from 'react';

const IFrameTest = () => {
    // useEffect(() => {
    //     const script = document.createElement("script");
    //     script.src = "https://www.currency.wiki/widget/embed?f=EUR&t=USD&a=1&fc=ffffff&c=A94442&g=on&sh=on&b=on&fl=on&p=c&s=off&mf=1&df=2&d=1&su=on&l=https://www.currency.wiki/&cd=8808907ce2483e3b39325779c309c812&w=200&h=350&lang=en-US";
    //     script.async = true;
    //
    //     const widgetContainer = document.getElementById("currency-widget-container");
    //     if (widgetContainer) {
    //         widgetContainer.appendChild(script);
    //     }
    //
    //     return () => {
    //         if (widgetContainer) {
    //             widgetContainer.innerHTML = ""; // Clean up the script on component unmount
    //         }
    //     };
    // }, []);

    useEffect(() => {
        const handleMessage = (event) => {
            console.log("Received message from iframe:", event.data);

            // Check if event data contains payment_status
            if (event.data && event.data.payment_status) {
                const { paypro_id, payment_status, message } = event.data;

                if (payment_status === "success") {
                    alert(`Payment Successful: ${message}\nPayPro ID: ${paypro_id}`);
                    // Perform redirect or UI updates
                    // window.location.href = "/payment-success";
                } else if (payment_status === "failure" || payment_status === "error") {
                    alert(`Payment Failed: ${message}\nPayPro ID: ${paypro_id}`);
                    // Redirect or show error message
                    // window.location.href = "/payment-failure";
                }
            }
        };

        // Add event listener
        window.addEventListener("message", handleMessage);

        // Cleanup on unmount
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    return (
        // <div style={{ width: '100%', height: '100%', border: '1px solid #ccc' }}>
        //
        //
        //     <div>
        //         {/* The link is for attribution as required */}
        //         <a href="https://www.currency.wiki/" rel="nofollow">
        //             Currency.Wiki
        //         </a>
        //         {/* Container where the widget will be embedded */}
        //         <div id="currency-widget-container"></div>
        //     </div>
        // </div>

        <div className="w-full h-screen ">
            <iframe
                className="w-full h-full "
                src="http://127.0.0.1:8000/iframe-card-checkout-demo?bid=MjYyMTI1MDk5MDAwMDY%3d"
            ></iframe>
        </div>
    );
}

export default IFrameTest;
